import { render } from "./Quotes.vue?vue&type=template&id=31f6e53e"
import script from "./Quotes.vue?vue&type=script&lang=ts"
export * from "./Quotes.vue?vue&type=script&lang=ts"
script.render = render

export default script